export default __webpack_public_path__ + "static/assets/b6451bd41221e0ebef9c83c079a6e194.png";